export default __webpack_public_path__ + "f0a7a217d47b6025f3945c1380b50969.png";